import React from "react";
import { useHistory } from "react-router-dom";
import "./InstructionPage.css";
import images from "../../../utilities/images/images";

const InstructionPage = ({ header, body }) => {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="instruction-page">
      <div className="instruction-header">
        <button className="back-btn" onClick={handleGoBack}>
          <img src={images.backBtn} alt="Go Back" />
        </button>
        <span className="header-content">{header}</span>
      </div>
      <div className="instruction-body">{body}</div>
    </div>
  );
};

export default InstructionPage;
